import * as types from '@/store/types'
import axios from 'axios'
import constConf from '../../../constconf'
export default {
    loadMessageRating: (context, botId) => {
        axios.defaults.withCredentials = true
        axios.get(constConf.message.url + '/stats/get-message-rating/' + botId).then(response => {
            // console.log('get_message_rating loaded')
            // console.log(response)
            if ((response.data.isArray || typeof response.data === 'object') && response.data.length !== 0) {
                context.commit('loadMessageRating', response.data)
            } else {
                context.commit('loadMessageRating', [])
            }
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get stats' + error)
        })
    },
    loadMessageSendInfo: (context, botId) => {
        axios.defaults.withCredentials = true
        axios.get(constConf.message.url + '/stats/get-message-send-info/' + botId + '?countDays=2&groupValue=14400 ').then(response => {
            // console.log('get_message_send_info')
            // console.log(response)
            if ((response.data.isArray || typeof response.data === 'object') && response.data.length !== 0) {
                context.commit('loadMessageSendInfo', response.data)
            } else {
                context.commit('loadMessageSendInfo', [])
            }
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get stats' + error)
        })
    },
    loadMessages: (context, payload) => {
        context.commit('setValueMessagesOutput', false)
        context.commit('setValueMessagesInput', false)
        context.dispatch('loadMessageSendInfoOutput', payload)
        context.dispatch('loadMessageSendInfoInput', payload)
    },
    loadMessageSendInfoOutput: (context, payload) => {
        axios.defaults.withCredentials = true
        return axios.get(constConf.message.url + '/stats/get-message-output/' + payload.botId + '?countDays=' + payload.countDays).then(response => {
            // console.log('get_message_send_info_output')
            // console.log(response)
            if ((response.data.isArray || typeof response.data === 'object') && response.data.length !== 0) {
                context.commit('loadMessageSendInfoOutput', response.data)
            } else {
                // context.commit('loadMessageSendInfoOutput', [])
            }
            return response.data
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get stats' + error)
        })
    },
    setValueLoadedMessagesOutput: (context, value) => {
        context.commit('setValueMessagesOutput', value)
    },
    loadMessageSendInfoInput: (context, payload) => {
        axios.defaults.withCredentials = true
        axios.get(constConf.message.url + '/stats/get-message-input/' + payload.botId + '?countDays=' + payload.countDays).then(response => {
            // console.log('get_message_send_info_input')
            // console.log(response)
            if ((response.data.isArray || typeof response.data === 'object') && response.data.length !== 0) {
                context.commit('loadMessageSendInfoInput', response.data)
            } else {
                // context.commit('loadMessageSendInfoInput', [])
            }
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get stats' + error)
        })
    },
    setValueLoadedMessagesInput: (context, value) => {
        context.commit('setValueMessagesInput', value)
    },
    loadMessageSendInfoMailing: (context, payload) => {
        axios.defaults.withCredentials = true
        axios.get(constConf.message.url + '/stats/get-message-mailing/' + payload.botId + '?countDays=' + payload.countDays).then(response => {
            // console.log('get_message_send_info_mailing')
            // console.log(response)
            if ((response.data.isArray || typeof response.data === 'object') && response.data.length !== 0) {
                context.commit('loadMessageSendInfoMailing', response.data)
            } else {
                context.commit('loadMessageSendInfoMailing', [])
            }
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get stats' + error)
        })
    },
    loadClientsSubscribeInfo: (context, payload) => {
        context.commit('setValueClientsSubscribe', false)
        axios.defaults.withCredentials = true
        axios.get(constConf.message.url + '/stats/get-clients-subscribe-info/' + payload.botId + '?countDays=' + payload.countDays).then(response => {
            // console.log('get_clients_subscribe_info ' + payload.countDays)
            // console.log(response.data)
            if ((response.data.isArray || typeof response.data === 'object') && response.data.length !== 0) {
                context.commit('loadClientsSubscribeInfo', response.data)
            } else {
                // context.commit('loadClientsSubscribeInfo', [])
            }
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get stats' + error)
        })
    },
    loadClientsUnsubscribeInfo: (context, payload) => {
        context.commit('setValueClientsUnsubscribe', false)
        axios.defaults.withCredentials = true
        axios.get(constConf.message.url + '/stats/get-clients-unsubscribe-info/' + payload.botId + '?countDays=' + payload.countDays).then(response => {
            // console.log('get_clients_subscribe_info ' + payload.countDays)
            // console.log(response.data)
            if ((response.data.isArray || typeof response.data === 'object') && response.data.length !== 0) {
                context.commit('loadClientsUnsubscribeInfo', response.data)
            } else {
                // context.commit('loadClientsUnsubscribeInfo', [])
            }
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get stats' + error)
        })
    }
}
